import React from 'react';

interface IProps {
  id: string;
  color: string;
  width: string;
  height: string;
}

const CartWidget: React.FC<IProps> = ({id, color, width, height}: IProps) => {
  return <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width={width} height={height} viewBox="0 0 512.000000 512.000000"
  id={id} preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill={color} stroke="none">
      <path d="M232 4940 c-48 -30 -72 -75 -72 -140 0 -65 24 -110 72 -140 31 -19
        51 -20 316 -20 155 0 282 -2 282 -5 0 -2 126 -541 280 -1196 154 -656 279
        -1193 278 -1194 -2 -1 -32 -9 -66 -18 -223 -61 -363 -237 -365 -462 -1 -134
        40 -241 125 -331 63 -67 131 -111 209 -135 58 -18 115 -19 1492 -19 1411 0
        1432 0 1465 20 95 58 99 216 5 277 -26 17 -100 18 -1438 23 -1400 5 -1410 5
        -1445 26 -107 63 -107 205 0 268 35 21 45 21 1465 26 1573 5 1449 0 1559 65
        51 30 146 127 170 174 33 63 46 115 222 860 190 810 194 835 159 958 -43 151
        -167 278 -316 324 -59 18 -120 19 -1723 19 l-1663 0 -28 118 c-108 465 -108
        466 -168 502 -30 19 -53 20 -407 20 -357 0 -377 -1 -408 -20z"/>
      <path d="M1768 1101 c-145 -47 -269 -174 -312 -320 -21 -71 -21 -211 0 -282
        43 -148 168 -274 315 -320 82 -26 216 -26 298 0 147 46 272 172 315 320 21 71
        21 211 0 282 -43 148 -168 274 -315 320 -81 25 -222 25 -301 0z"/>
      <path d="M3528 1101 c-74 -24 -144 -69 -200 -129 -91 -97 -128 -194 -128 -332
        0 -138 37 -235 128 -332 95 -101 206 -148 352 -148 146 0 257 47 352 148 91
        97 128 194 128 332 0 138 -37 235 -128 332 -57 61 -127 105 -203 129 -81 25
        -222 25 -301 0z"/>
    </g>
  </svg>
};

export default CartWidget;